import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  CheckCircle2,
  Clock,
  Download,
  ExternalLink,
  FileText,
  Info,
  PenTool,
  RefreshCw,
  ShieldCheck,
  Send,
  Save,
  PenLine,
  CalendarDays,
  FileSignature,
  UserRound,
  ChevronRight,
  ChevronLeft,
  Eye,
  X,
  RotateCcw,
} from 'lucide-react';
import { useToast } from '../../../Utils/toastContext';
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import PDFViewer from './customer-pdf-viewer';
import { debounce } from 'lodash';
const BASE_URL = process.env.REACT_APP_BASE_URL;

const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return 'N/A';

  const date = new Date(dateTimeString);
  if (Number.isNaN(date.getTime())) return 'N/A';

  const pad = (n) => String(n).padStart(2, '0');

  const formatted =
    `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;

  return formatted;
};

export default function CustomerTemplateViewer() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);
  const { contractId } = useParams();
  const [loading, setLoading] = useState(false);
  const [contract, setContract] = useState(null);
  const [showFieldModal, setShowFieldModal] = useState(false);
  const [fieldValues, setFieldValues] = useState({});
  const [signatureValue, setSignatureValue] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const documentTitle = contract?.title || 'Contract document';
  const loggedInUserId = useSelector((state) => state.user.userId);
  console.log('loggedInUserId', loggedInUserId);
  console.log('contract', contract);
  console.log('contract recepee', contract?.signer_recipients);
  const currentSignerRecipient =
    contract?.signer_recipients?.find((recipient) => {
      const recipientUserId = recipient?.user_id ?? recipient?.userId;
      console.log('recipientUserId', recipientUserId);
      return (
        recipientUserId != null &&
        String(recipientUserId) === String(loggedInUserId)
      );
    }) || null;
  const recipientStatus = contract?.customer_status || 'pending';
  const recipientState = String(recipientStatus).toLowerCase();
  const isSigned = [
    'signed',
    'completed',
    'complete',
    'approved',
    'done',
  ].includes(recipientState);
  const signingLabel = isSigned
    ? 'Completed'
    : recipientState === 'viewed'
      ? 'Viewed'
      : 'Pending';
  const signingTone = isSigned
    ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
    : 'border-amber-200 bg-amber-50 text-amber-700';
  console.log('currentSignerRecipient', currentSignerRecipient);
  const recipientActivityTime = contract?.completed_at
    ? formatDateTime(contract?.completed_at)
    : 'Awaiting';
  const signatureField = currentSignerRecipient?.signed_fields?.find(
    (field) => field.type === 'signature' && field.signature_image_url,
  );
  const signingFields = [
    ...(contract?.signing_form?.fields || []),
    ...(contract?.signing_form?.signature || []),
  ];
  const signatureImageUrl = signatureField?.signature_image_url || null;
  const GetAPIcalls = useCallback(
    async (url, isBlob = false) => {
      const token = localStorage.getItem('jwtToken');
      const apiUrl = `${BASE_URL}${url}`;

      const headers = {};
      if (token) headers.Authorization = `Bearer ${token}`;

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired.');
        }

        const errorData = await response.json().catch(() => ({
          message: 'Unexpected error',
        }));

        throw new Error(errorData.message);
      }

      return isBlob ? response.blob() : response.json();
    },
    [navigate],
  );

  const getContractDetail = async () => {
    if (!contractId) return;

    try {
      setIsLoadingPdf(true);
      const blob = await GetAPIcalls(
        `/api/v1/customer/contracts/${contractId}/pdf`,
        true,
      );
      const fileURL = URL.createObjectURL(blob);

      setPdfUrl(fileURL);
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setIsLoadingPdf(false);
    }
  };
  const updateFieldValue = (field, value) => {
    setFieldValues((prev) => ({
      ...prev,
      [field.field_id]: {
        field_id: field.field_id,
        field_type: field.type,
        value,
      },
    }));
  };
  // const submitFields = async () => {
  //   const normalFields = Object.values(fieldValues);

  //   // add same signature to all signature fields
  //   const signatureFields =
  //     contract?.signing_form?.signature?.map((signature) => ({
  //       field_id: signature.field_id,
  //       field_type: 'signature',
  //       value: signatureValue,
  //     })) || [];

  //   const payload = {
  //     consent_given: true,
  //     fields: [
  //       ...normalFields.filter((item) => item.field_type !== 'signature'),
  //       ...signatureFields,
  //     ],
  //   };

  //   console.log(payload);
  // };
  const prepareSignaturePayload = () => {
    return (
      contract?.signing_form?.signature?.map((signature) => {
        const isBase64Signature =
          signatureValue &&
          typeof signatureValue === 'string' &&
          signatureValue.startsWith('data:image');

        return {
          field_id: signature.field_id,
          field_type: 'signature',
          ...(isBase64Signature
            ? {
                signature_data: signatureValue,
              }
            : {
                value: signatureValue,
              }),
        };
      }) || []
    );
  };
  const postdraftAPI = async (payload) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const apiUrl = `${BASE_URL}/api/v1/customer/contracts/${contractId}/fields`;

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const postSubmitAPI = async (payload) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const apiUrl = `${BASE_URL}/api/v1/customer/contracts/${contractId}/sign`;

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const submitFields = useCallback(
    debounce(async () => {
      const normalFields = Object.values(fieldValues);

      // 🔹 Get required fields from contract
      const requiredFields =
        contract?.signing_form?.fields?.filter((f) => f.required) || [];

      // 🔹 Validate required fields
      const missingFields = requiredFields.filter((field) => {
        const value = fieldValues[field.field_id]?.value;

        return (
          value === undefined ||
          value === null ||
          value === '' ||
          (field.type === 'checkbox' && value !== 'checked')
        );
      });

      // 🔹 Validate signature
      const hasSignatureFields = contract?.signing_form?.signature?.length > 0;

      const isSignatureMissing =
        hasSignatureFields && (!signatureValue || signatureValue.trim() === '');

      // ❌ STOP if validation fails
      if (missingFields.length > 0) {
        showToast('Please fill all required fields', 'error');
        return;
      }

      if (isSignatureMissing) {
        showToast('Please add your signature', 'error');
        return;
      }

      setLoading(true);

      // 🔹 Prepare signature payload
      const signatureFields = prepareSignaturePayload();

      const payload = {
        consent_given: true,
        fields: [
          ...normalFields.filter((item) => item.field_type !== 'signature'),
          ...signatureFields,
        ],
      };

      try {
        const response = await postSubmitAPI(payload);

        if (response.status === 200) {
          showToast(response.message, 'success');
          navigate(-1);
        }
      } catch (error) {
        showToast(error.message, 'error');
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 500);
      }
    }, 500),
    [signatureValue, fieldValues, contract],
  );
  const saveDraft = async () => {
    // Validate at least one field is filled
    const hasFilledField = Object.values(fieldValues).some(
      (field) => field?.value && String(field.value).trim() !== '',
    );

    const hasSignature = signatureValue && String(signatureValue).trim() !== '';

    if (!hasFilledField && !hasSignature) {
      showToast(
        'Please complete at least one field before saving draft.',
        'error',
      );
      return;
    }

    setLoading(true);
    const signatureFields = prepareSignaturePayload();

    const payload = {
      consent_given: true,
      fields: [...Object.values(fieldValues), ...signatureFields],
    };
    console.log('DRAFT PAYLOAD', payload);
    try {
      const response = await postdraftAPI(payload);

      if (response.status === 200) {
        showToast(response.message, 'success');
        return response;
      }
    } catch (error) {
      showToast(error.message, 'error');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };
  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/customer/contracts/${contractId}`,
      );

      if (response.status === 200) {
        const contractData = response.data.contract;

        setContract(contractData);

        // prepare existing values if any
        const form = contractData.signing_form;

        const existingValues = {};

        [...(form?.fields || []), ...(form?.signature || [])].forEach(
          (field) => {
            existingValues[field.field_id] = {
              field_id: field.field_id,
              field_type: field.type,
              value: field.value || '',
            };
          },
        );

        setFieldValues(existingValues);
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  useEffect(() => {
    getContractDetail();
    getDetails();
  }, [contractId]);

  useEffect(() => {
    return () => {
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    };
  }, [pdfUrl]);

  const viewerUrl = pdfUrl || '';
  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top_left,_rgba(55,90,231,0.18),_transparent_32%),linear-gradient(135deg,_#f8fbff_0%,_#fff7ed_48%,_#f0fdfa_100%)]">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <ContractHeader contract={contract} documentTitle={documentTitle} />
      <main className="mx-auto flex w-full max-w-7xl flex-col gap-5 px-3 py-4 sm:px-6 lg:px-8">
        <section className="overflow-hidden rounded-[32px] border border-slate-200/80 bg-white/70 shadow-[0_30px_90px_-35px_rgba(15,23,42,0.35)] backdrop-blur-xl">
          <div className="flex flex-col gap-4 border-b border-slate-200/70 bg-gradient-to-r from-slate-900 via-slate-800 to-indigo-950 px-4 py-4 sm:px-5 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex min-w-0 items-center gap-3">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-cyan-400 via-sky-500 to-indigo-500 text-white shadow-lg shadow-cyan-200/40">
                <FileText size={20} />
              </div>

              <div className="min-w-0">
                <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-cyan-300">
                  Review the latest version.
                </p>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-2">
              <button
                type="button"
                onClick={getContractDetail}
                disabled={isLoadingPdf}
                className="inline-flex h-10 items-center gap-2 rounded-xl border border-slate-200/70 bg-white/90 px-3 text-sm font-medium text-slate-700 shadow-sm transition hover:-translate-y-0.5 hover:border-cyan-300 hover:text-cyan-700 hover:shadow-md disabled:cursor-not-allowed disabled:opacity-60"
              >
                <RefreshCw
                  size={16}
                  className={isLoadingPdf ? 'animate-spin' : ''}
                />
                Refresh
              </button>

              <a
                href={pdfUrl || undefined}
                download={`${documentTitle}.pdf`}
                className={`inline-flex h-10 items-center gap-2 rounded-xl border px-3 text-sm font-medium shadow-sm transition ${
                  pdfUrl
                    ? 'border-slate-200/70 bg-white/90 text-slate-700 hover:-translate-y-0.5 hover:border-amber-300 hover:text-amber-700 hover:shadow-md'
                    : 'pointer-events-none border-slate-100 bg-slate-50 text-slate-300'
                }`}
              >
                <Download size={16} />
                Download
              </a>

              <a
                href={pdfUrl || undefined}
                target="_blank"
                rel="noreferrer"
                className={`inline-flex h-10 w-10 items-center justify-center rounded-xl shadow-sm transition ${
                  pdfUrl
                    ? 'bg-white/90 text-slate-800 hover:-translate-y-0.5 hover:bg-[#375AE7] hover:text-white hover:shadow-md'
                    : 'pointer-events-none bg-slate-200 text-slate-400'
                }`}
                title="Open in new tab"
                aria-label="Open in new tab"
              >
                <ExternalLink size={17} />
              </a>
              {contract?.signing_form?.your_turn && (
                <button
                  onClick={() => setShowFieldModal(true)}
                  className="
inline-flex h-10 items-center gap-2 rounded-xl
bg-[#375AE7]
px-4 text-sm font-semibold text-white
shadow-md hover:bg-indigo-700
"
                >
                  <PenTool size={16} />
                  Fill Contract Fields
                </button>
              )}
            </div>
          </div>

          <div
            className="
    grid
    gap-5
    rounded-[32px]
    bg-gradient-to-br
    from-slate-50
    via-white
    to-blue-50/40
    p-3
    sm:p-5
    lg:grid-cols-[minmax(0,1fr)_340px]
  "
          >
            {/* DOCUMENT PREVIEW */}

            <div
              className="
    relative
    overflow-hidden
    rounded-[28px]
    bg-white
    shadow-[0_20px_60px_-30px_rgba(15,23,42,0.25)]
    ring-1
    ring-slate-200/70
  "
            >
              <div
                className="
    flex
    min-h-[calc(100vh-320px)]
    justify-center
    overflow-hidden
    rounded-[28px]
    bg-slate-300

    p-3
    sm:min-h-[calc(100vh-280px)]
    sm:p-5
  "
              >
                {/* {!isLoadingPdf && pdfUrl && !isSigned && ( */}
                <div
                  className="
h-[66vh]
min-h-[420px]
w-full
overflow-y-auto
rounded-2xl
sm:h-[72vh]
"
                >
                  {isLoadingPdf && (
                    <div
                      className="
flex
h-full
min-h-[420px]
items-center
justify-center
"
                    >
                      <div
                        className="
rounded-3xl
bg-white
px-8
py-7
text-center
shadow-xl
ring-1
ring-slate-200
"
                      >
                        <div
                          className="
mx-auto
mb-4
h-12
w-12
animate-spin
rounded-full
border-4
border-blue-100
border-t-[#375AE7]
"
                        />

                        <p
                          className="
font-semibold
text-slate-900
"
                        >
                          Preparing document
                        </p>

                        <p
                          className="
mt-1
text-sm
text-slate-500
"
                        >
                          Loading secure preview...
                        </p>
                      </div>
                    </div>
                  )}
                  <PDFViewer url={viewerUrl} />
                </div>
                {/* )} */}

                {/* {!isLoadingPdf && pdfUrl && isSigned && (
                  <div
                    className="
h-[66vh]
min-h-[420px]
w-full
overflow-y-auto
rounded-2xl
sm:h-[72vh]
"
                  >
                    <PDFViewer url={contract.signed_preview_pdf_url} />
                  </div>
                )} */}

                {!isLoadingPdf && !pdfUrl && (
                  <div
                    className="
flex
min-h-[420px]
items-center
justify-center
"
                  >
                    <div
                      className="
max-w-sm
text-center
"
                    >
                      <div
                        className="
mx-auto
mb-4
flex
h-16
w-16
items-center
justify-center
rounded-3xl
bg-rose-50
text-rose-500
"
                      >
                        <FileText size={28} />
                      </div>

                      <h3
                        className="
font-semibold
text-slate-900
"
                      >
                        Preview unavailable
                      </h3>

                      <p
                        className="
mt-2
text-sm
leading-relaxed
text-slate-500
"
                      >
                        The document preview could not be loaded. Please refresh
                        and try again.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* RIGHT PANEL */}

            <aside
              className="
space-y-4
"
            >
              <div
                className="
rounded-[28px]
bg-white
p-5
shadow-[0_15px_40px_-25px_rgba(15,23,42,0.25)]
ring-1
ring-slate-200/70
"
              >
                {/* STATUS */}

                <div
                  className="
flex
items-start
justify-between
gap-4
"
                >
                  <div>
                    <p
                      className="
text-[11px]
font-bold
uppercase
tracking-[0.18em]
text-slate-400
"
                    >
                      Current status
                    </p>

                    <h3
                      className="
mt-1
text-lg
font-bold
text-slate-900
"
                    >
                      {signingLabel === 'Viewed'
                        ? 'Document Viewed'
                        : `Signature ${signingLabel}`}
                    </h3>
                  </div>

                  <span
                    className={`
rounded-full
px-3
py-1.5
text-xs
font-semibold
${signingTone}
`}
                  >
                    {signingLabel}
                  </span>
                </div>

                {/* SIGNATURE CARD */}

                <div
                  className="
mt-5
rounded-3xl
bg-gradient-to-br
from-blue-50
via-white
to-indigo-50
p-4
ring-1
ring-blue-100
"
                >
                  <div
                    className="
flex
items-center
justify-between
rounded-2xl
bg-white
p-3
shadow-sm
"
                  >
                    <div
                      className="
flex
items-center
gap-3
"
                    >
                      <div
                        className="
flex
h-10
w-10
items-center
justify-center
rounded-xl
bg-blue-50
text-[#375AE7]
"
                      >
                        <PenTool size={18} />
                      </div>

                      <div>
                        <p
                          className="
text-sm
font-semibold
text-slate-900
"
                        >
                          Your signature
                        </p>

                        <p
                          className="
text-xs
text-slate-500
"
                        >
                          Verification status
                        </p>
                      </div>
                    </div>

                    {isSigned ? (
                      <CheckCircle2 size={20} className="text-emerald-500" />
                    ) : (
                      <div
                        className="
h-3
w-3
rounded-full
bg-amber-400
"
                      />
                    )}
                  </div>

                  <div
                    className="
mt-4
rounded-2xl
bg-white
p-5
text-center
shadow-sm
"
                  >
                    <div
                      className="
mx-auto
mb-3
flex
h-14
w-14
items-center
justify-center
rounded-2xl
bg-blue-50
text-[#375AE7]
"
                    >
                      {isSigned ? (
                        <CheckCircle2 size={24} />
                      ) : (
                        <PenTool size={24} />
                      )}
                    </div>

                    <p
                      className="
font-semibold
text-slate-900
"
                    >
                      {isSigned ? 'Signature completed' : 'Signature pending'}
                    </p>

                    {!isSigned && (
                      <p
                        className="
mt-2
text-sm
leading-relaxed
text-slate-500
"
                      >
                        No signature recorded yet. Complete the signing process
                        to continue.
                      </p>
                    )}
                  </div>
                </div>

                <div
                  className="
mt-4
flex
items-center
justify-between
rounded-2xl
bg-slate-50
px-4
py-3
"
                >
                  <span
                    className="
text-sm
text-slate-500
"
                  >
                    Completed At
                  </span>

                  <span
                    className="
text-sm
font-semibold
text-slate-900
"
                  >
                    {recipientActivityTime}
                  </span>
                </div>
              </div>
            </aside>
          </div>
        </section>
      </main>
      {showFieldModal && (
        <FieldAssignmentModal
          fields={signingFields}
          signatureFields={contract?.signing_form?.signature}
          signatureValue={signatureValue}
          setSignatureValue={setSignatureValue}
          values={fieldValues}

          onChange={updateFieldValue}

          onClose={() => setShowFieldModal(false)}

          onSaveDraft={saveDraft}

          onSubmit={submitFields}
          contract={contract}
        />
      )}
    </div>
  );
}

function SignatureCanvas({ onChange }) {
  const canvasRef = useRef(null);
  const drawingRef = useRef(false);
  const [hasSignature, setHasSignature] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // Smooth drawing settings
    ctx.lineWidth = 2.5;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.strokeStyle = '#111827';

    const getPosition = (e) => {
      const rect = canvas.getBoundingClientRect();

      if (e.touches) {
        return {
          x: e.touches[0].clientX - rect.left,
          y: e.touches[0].clientY - rect.top,
        };
      }

      return {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      };
    };

    const startDrawing = (e) => {
      drawingRef.current = true;

      const { x, y } = getPosition(e);

      ctx.beginPath();
      ctx.moveTo(x, y);
    };

    const draw = (e) => {
      if (!drawingRef.current) return;

      e.preventDefault();

      const { x, y } = getPosition(e);

      ctx.lineTo(x, y);
      ctx.stroke();

      setHasSignature(true);
    };

    const stopDrawing = () => {
      if (!drawingRef.current) return;

      drawingRef.current = false;
      ctx.beginPath();

      const base64 = canvas.toDataURL('image/png');

      onChange(base64);
    };

    canvas.addEventListener('mousedown', startDrawing);
    canvas.addEventListener('mousemove', draw);
    canvas.addEventListener('mouseup', stopDrawing);

    // Touch support
    canvas.addEventListener('touchstart', startDrawing);
    canvas.addEventListener('touchmove', draw);
    canvas.addEventListener('touchend', stopDrawing);

    return () => {
      canvas.removeEventListener('mousedown', startDrawing);
      canvas.removeEventListener('mousemove', draw);
      canvas.removeEventListener('mouseup', stopDrawing);

      canvas.removeEventListener('touchstart', startDrawing);
      canvas.removeEventListener('touchmove', draw);
      canvas.removeEventListener('touchend', stopDrawing);
    };
  }, [onChange]);

  const clearSignature = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    setHasSignature(false);

    // clear parent value
    onChange(null);
  };

  return (
    <div className="w-full max-w-2xl rounded-xl border bg-white shadow-sm p-5">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="p-2 rounded-lg bg-blue-50 text-blue-600">
            <PenLine size={18} />
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-900">
              Draw your signature
            </h3>

            <p className="text-xs text-gray-500">
              Use your mouse or touch screen
            </p>
          </div>
        </div>

        <button
          type="button"
          disabled={!hasSignature}
          onClick={clearSignature}
          className={`
            flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium
            transition-all
            ${
              hasSignature
                ? 'bg-gray-100 text-gray-700 hover:bg-red-50 hover:text-red-600'
                : 'bg-gray-50 text-gray-300 cursor-not-allowed'
            }
          `}
        >
          <RotateCcw size={15} />
          Clear
        </button>
      </div>

      {/* Canvas Area */}
      <div
        className="
          relative rounded-xl border-2 border-dashed
          border-gray-200 bg-gray-50
          overflow-hidden
        "
      >
        {!hasSignature && (
          <div
            className="
              absolute inset-0 flex items-center justify-center
              pointer-events-none text-gray-400 text-sm
            "
          >
            Start drawing here
          </div>
        )}

        <canvas
          ref={canvasRef}
          width={600}
          height={220}
          className="
            w-full h-[220px]
            cursor-crosshair
            touch-none
          "
        />
      </div>

      {hasSignature && (
        <p className="mt-3 text-xs text-green-600">✓ Signature captured</p>
      )}
    </div>
  );
}

function FieldAssignmentModal({
  fields,
  signatureFields,
  signatureValue,
  setSignatureValue,
  values,
  onChange,
  onClose,
  onSaveDraft,
  onSubmit,
  contract,
}) {
  const { showToast } = useToast();

  const [signatureMode, setSignatureMode] = useState('upload');
  const [step, setStep] = useState(1);
  const [draftId, setDraftId] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);
  const [isSavingDraft, setIsSavingDraft] = useState(false);
  const navigate = useNavigate();

  const normalFields =
    fields?.filter((field) => field.type !== 'signature') || [];
  const validateFields = () => {
    const requiredFields = normalFields.filter((field) => field.required);

    const missing = requiredFields.some(
      (field) => !values[field.field_id]?.value,
    );

    if (missing) {
      return false;
    }

    if (signatureFields?.length && !signatureValue) {
      return false;
    }

    return true;
  };
  const getPdf = async () => {
    try {
      setIsLoadingPdf(true);

      const response = await GetAPIcalls(
        `/api/v1/customer/contracts/${contract.contract_id}`,
      );

      const pdfUrl = response.data.contract.signed_preview_pdf_url;

      if (pdfUrl) {
        setPreviewUrl(pdfUrl);
        setStep(2);
      }
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setIsLoadingPdf(false);
    }
  };
  const GetAPIcalls = useCallback(
    async (url, isBlob = false) => {
      const token = localStorage.getItem('jwtToken');
      const apiUrl = `${BASE_URL}${url}`;

      const headers = {};
      if (token) headers.Authorization = `Bearer ${token}`;

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired.');
        }

        const errorData = await response.json().catch(() => ({
          message: 'Unexpected error',
        }));

        throw new Error(errorData.message);
      }

      return isBlob ? response.blob() : response.json();
    },
    [navigate],
  );
  const handleSignatureUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      const base64 = reader.result; // already base64 string
      setSignatureValue(base64);
    };

    reader.readAsDataURL(file);
  };
  const handleReview = async () => {
    if (!validateFields()) {
      showToast(
        'Please complete all required fields and signature before review.',
        'error',
      );
      return;
    }

    try {
      setIsSavingDraft(true);

      // ✅ 1. Save Draft (IMPORTANT: remove debounce OR wrap properly)
      const response = await onSaveDraft();

      if (response?.status === 200) {
        console.log('Draft saved');

        // ✅ 2. Fetch latest PDF
        await getPdf(); // this sets pdfUrl

        // ✅ 3. Move to preview step ONLY after PDF ready
        setStep(2);
      } else {
        showToast('Failed to save draft', 'error');
      }
    } catch (error) {
      console.error(error);
      showToast(error.message || 'Something went wrong', 'error');
    } finally {
      setIsSavingDraft(false);
    }
  };
  return (
    <div
      className="
fixed inset-0 z-50
flex items-center justify-center
bg-slate-950/60 backdrop-blur-sm
p-3 sm:p-6
"
    >
      <div
        className="
w-full
max-w-2xl
rounded-[32px]
bg-white
shadow-2xl
overflow-hidden
max-h-[90vh]
flex
flex-col
"
      >
        {/* HEADER */}

        <div
          className="
bg-gradient-to-r
from-[#375AE7]
via-indigo-600
to-purple-600
px-6
py-5
text-white
"
        >
          <div className="flex justify-between items-start">
            <div>
              <div
                className="
flex items-center gap-2
text-blue-100
text-xs
uppercase
tracking-wider
font-semibold
"
              >
                <FileSignature size={15} />
                Contract Completion
              </div>

              <h2
                className="
text-2xl
font-bold
mt-2
"
              >
                Complete Required Details
              </h2>

              <p
                className="
text-sm
text-blue-100
mt-1
"
              >
                Review and complete the requested information before submitting.
              </p>
            </div>

            <button
              onClick={onClose}
              className="
h-9 w-9
rounded-full
bg-white/20
flex items-center justify-center
hover:bg-white/30
"
            >
              <X size={18} />
            </button>
          </div>
        </div>
        <div className="px-6 py-6 border-b bg-white">
          <div className="relative flex items-center justify-between">
            {/* Background Line - node to node */}
            <div className="absolute top-4 left-[16.66%] right-[16.66%] h-[2px] bg-slate-200 z-0" />

            {/* Active Progress Line - node to node */}
            <div
              className="absolute top-4 left-[16.66%] h-[2px] bg-[#375AE7] z-0 transition-all duration-300"
              style={{
                width: `${((step - 1) / (3 - 1)) * 66.66}%`,
              }}
            />

            {[
              { id: 1, label: 'Details' },
              { id: 2, label: 'Review' },
              { id: 3, label: 'Submit' },
            ].map((item) => (
              <div
                key={item.id}
                className="relative z-10 flex flex-col items-center flex-1"
              >
                {/* Step Circle */}
                <div
                  className={`
            h-8 w-8 rounded-full flex items-center justify-center
            text-xs font-bold transition-all duration-300

            ${
              step > item.id
                ? 'bg-[#375AE7] text-white'
                : step === item.id
                  ? 'bg-[#375AE7] text-white ring-4 ring-blue-100'
                  : 'bg-slate-200 text-slate-500'
            }
          `}
                >
                  {step > item.id ? <CheckCircle2 size={15} /> : item.id}
                </div>

                {/* Label */}
                <span
                  className={`
            mt-2 text-sm font-semibold transition-colors

            ${
              step === item.id
                ? 'text-[#375AE7]'
                : step > item.id
                  ? 'text-slate-700'
                  : 'text-slate-400'
            }
          `}
                >
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
        {/* CONTENT */}

        <div
          className="
overflow-y-auto
p-5 sm:p-6
space-y-6
flex-1
"
        >
          {/* USER INFO */}
          {step === 1 && (
            <>
              <div
                className="
rounded-2xl
border
border-blue-100
bg-blue-50/70
p-4
flex
gap-3
"
              >
                <div
                  className="
h-11
w-11
rounded-xl
bg-white
flex
items-center
justify-center
shadow-sm
text-[#375AE7]
"
                >
                  <UserRound size={22} />
                </div>

                <div>
                  <p className="text-xs text-slate-500">Completing as</p>

                  <p
                    className="
font-semibold
text-slate-900
"
                  >
                    {contract?.signing_form?.recipient?.name}
                  </p>

                  <p
                    className="
text-xs
text-slate-500
capitalize
"
                  >
                    {contract?.signing_form?.recipient?.role}
                  </p>
                </div>
              </div>

              {/* NORMAL FIELDS */}

              <div>
                <div
                  className="
flex items-center gap-2 mb-3
"
                >
                  <Info size={18} className="text-[#375AE7]" />

                  <h3
                    className="
font-bold
text-slate-900
"
                  >
                    Required Information
                  </h3>
                </div>

                <div className="space-y-4">
                  {normalFields.map((field) => (
                    <div
                      key={field.field_id}
                      className="
rounded-2xl
border
border-slate-200
bg-white
p-4
hover:border-blue-300
transition
"
                    >
                      <div
                        className="
flex justify-between
gap-3
mb-3
"
                      >
                        <div>
                          <p
                            className="
font-semibold
text-slate-800
"
                          >
                            {field.label == 'dateField' ? 'Date' : field.label}
                          </p>

                          <p
                            className="
text-xs
text-slate-400
mt-1
flex gap-1
items-center
"
                          >
                            <FileSignature size={12} />
                            Page {field.page} •
                            {field.required ? 'Required' : 'Optional'}
                          </p>
                        </div>

                        {values[field.field_id]?.value && (
                          <CheckCircle2
                            size={20}
                            className="text-emerald-500"
                          />
                        )}
                      </div>

                      {/* DATE */}

                      {field.type === 'date' && (
                        <div
                          className="
relative
"
                        >
                          <CalendarDays
                            className="
absolute left-3 top-3
text-slate-400
"
                            size={18}
                          />

                          {/* <input
                        type="date"
                        className="
w-full
rounded-xl
border
border-slate-200
pl-10
p-3
focus:ring-2
focus:ring-blue-500
outline-none
"
                        value={values[field.field_id]?.value || ''}
                        onChange={(e) => onChange(field, e.target.value)}
                      /> */}

                          <DatePicker
                            selected={values[field.field_id]?.value || ''}
                            onChange={(date) => onChange(field, date)}
                            dateFormat="dd/MM/yyyy"

                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="scroll" // 🔥 FIX (instead of "select")
                            yearDropdownItemNumber={100} // 🔥 show 100 years
                            scrollableYearDropdown // 🔥 smooth scroll
                            placeholderText="Select Date"
                            wrapperClassName="w-full"
                            className="
w-full
rounded-xl
border
border-slate-200
pl-10
p-3
focus:ring-2
focus:ring-blue-500
outline-none
"
                          />
                        </div>
                      )}

                      {/* CHECKBOX */}

                      {field.type === 'checkbox' && (
                        <label
                          className="
flex
items-center
gap-3
cursor-pointer
rounded-xl
bg-slate-50
p-3
"
                        >
                          <input
                            type="checkbox"
                            className="h-5 w-5"
                            checked={
                              values[field.field_id]?.value === 'checked'
                            }
                            onChange={(e) =>
                              onChange(field, e.target.checked ? 'checked' : '')
                            }
                          />

                          <span className="text-sm">
                            I confirm and accept this information
                          </span>
                        </label>
                      )}

                      {/* RADIO */}

                      {field.type === 'radio' && (
                        <div
                          className="
grid
grid-cols-2
gap-3
"
                        >
                          {field.options?.map((option) => (
                            <label
                              key={option}
                              className={`
cursor-pointer
rounded-xl
border
p-3
flex
gap-2
items-center
${
  values[field.field_id]?.value === option
    ? 'border-blue-500 bg-blue-50'
    : 'border-slate-200'
}
`}
                            >
                              <input
                                type="radio"
                                name={field.field_id}
                                checked={
                                  values[field.field_id]?.value === option
                                }
                                onChange={() => onChange(field, option)}
                              />

                              {option}
                            </label>
                          ))}
                        </div>
                      )}

                      {/* TEXT */}

                      {field.type === 'placeholder' && (
                        <input
                          className="
w-full
rounded-xl
border
border-slate-200
p-3
focus:ring-2
focus:ring-blue-500
outline-none
"
                          placeholder={`Enter ${field.label}`}
                          value={values[field.field_id]?.value || ''}
                          onChange={(e) => onChange(field, e.target.value)}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* SIGNATURE */}

              <div>
                <div
                  className="
flex items-center gap-2 mb-3
"
                >
                  <PenLine size={18} className="text-purple-600" />

                  <h3 className="font-bold">Your Signature</h3>
                </div>

                <div
                  className="
rounded-2xl
border
border-purple-200
bg-purple-50/50
p-4
"
                >
                  <p
                    className="
text-sm
text-slate-600
mb-3
"
                  >
                    This signature will be applied automatically to:
                  </p>

                  <div
                    className="
space-y-2 mb-4
"
                  >
                    {signatureFields?.map((item, index) => (
                      <div
                        key={item.field_id}
                        className="
flex
items-center
justify-between
rounded-xl
bg-white
border
p-3
"
                      >
                        <span className="text-sm font-medium">
                          Signature {index + 1}
                        </span>

                        <span className="text-xs text-slate-500">
                          Page {item.page}
                        </span>
                      </div>
                    ))}
                  </div>

                  {/* SIGNATURE TYPE */}

                  <div
                    className="
flex gap-2
mb-4
"
                  >
                    {['upload', 'draw', 'name'].map((mode) => (
                      <button
                        key={mode}
                        onClick={() => {
                          setSignatureValue('');
                          setSignatureMode(mode);
                        }}
                        className={`
flex-1
rounded-xl
py-2
text-sm
font-semibold
capitalize
${signatureMode === mode ? 'bg-[#375AE7] text-white' : 'bg-white border'}
`}
                      >
                        {mode}
                      </button>
                    ))}
                  </div>

                  {signatureMode === 'upload' && (
                    <div className="w-full">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Upload Signature
                      </label>

                      <div className="relative border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-black transition cursor-pointer bg-gray-50">
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleSignatureUpload}
                          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                        />

                        {!signatureValue ? (
                          <div className="flex flex-col items-center gap-2">
                            <div className="text-3xl">✍️</div>
                            <p className="text-sm font-medium text-gray-700">
                              Click or drag to upload
                            </p>
                            <p className="text-xs text-gray-400">
                              PNG, JPG up to 2MB
                            </p>
                          </div>
                        ) : (
                          <div className="flex flex-col items-center gap-3">
                            <img
                              src={signatureValue}
                              alt="signature preview"
                              className="h-20 object-contain"
                            />

                            <button
                              type="button"
                              onClick={() => setSignatureValue(null)}
                              className="text-xs text-red-500 hover:underline"
                            >
                              Remove & re-upload
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {signatureMode === 'name' && (
                    <input
                      className="
w-full
rounded-xl
border
p-3
"
                      placeholder="Enter your full name"
                      value={signatureValue}
                      onChange={(e) => setSignatureValue(e.target.value)}
                    />
                  )}

                  {signatureMode === 'draw' && (
                    <div>
                      <p
                        className="
text-xs
text-slate-500
mb-3
"
                      >
                        Draw your signature using mouse, trackpad or touch
                        screen
                      </p>

                      <SignatureCanvas
                        onChange={(image) => setSignatureValue(image)}
                      />
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
          {step === 2 && (
            <div
              className="
space-y-5
"
            >
              <div
                className="
rounded-2xl
bg-blue-50
border border-blue-100
p-4
"
              >
                <div
                  className="
flex items-center gap-3
"
                >
                  <Eye className="text-[#375AE7]" />

                  <div>
                    <h3
                      className="
font-bold text-slate-900
"
                    >
                      Review Contract
                    </h3>

                    <p
                      className="
text-sm text-slate-500
"
                    >
                      Please review your completed document before submission.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className="
h-[60vh]
rounded-2xl
overflow-hidden
bg-slate-100
"
              >
                <PDFViewer url={previewUrl} />
              </div>
            </div>
          )}
          {step === 3 && (
            <div
              className="
rounded-3xl
bg-white
border
p-8
text-center
"
            >
              <div
                className="
mx-auto
h-16
w-16
rounded-full
bg-emerald-100
flex
items-center
justify-center
"
              >
                <CheckCircle2 className="text-emerald-600" size={32} />
              </div>

              <h2
                className="
mt-5
text-xl
font-bold
"
              >
                Ready to Submit
              </h2>

              <p
                className="
mt-2
text-slate-500
"
              >
                Your contract has been reviewed successfully.
              </p>
            </div>
          )}
        </div>

        {/* FOOTER */}

        <div
          className="
border-t
p-4
bg-slate-50
flex
justify-between
gap-3
"
        >
          {step > 1 && (
            <button
              onClick={() => setStep(step - 1)}

              className="
rounded-xl
border
bg-white
px-5
py-3
font-semibold
flex
items-center
gap-2
"
            >
              <ChevronLeft size={18} />
              Back
            </button>
          )}

          <div className="ml-auto">
            {step === 1 && (
              <button
                disabled={isSavingDraft}

                onClick={handleReview}

                className="
rounded-xl
bg-[#375AE7]
text-white
px-6
py-3
font-semibold
flex
items-center
gap-2
"
              >
                {isSavingDraft ? 'Saving...' : 'Review Document'}

                <ChevronRight size={18} />
              </button>
            )}

            {step === 2 && (
              <button
                onClick={() => setStep(3)}

                className="
rounded-xl
bg-[#375AE7]
text-white
px-6
py-3
font-semibold
"
              >
                Continue
              </button>
            )}

            {step === 3 && (
              <button
                onClick={onSubmit}

                className="
rounded-xl
bg-emerald-600
text-white
px-6
py-3
font-semibold
flex
items-center
gap-2
"
              >
                <Send size={18} />
                Submit Contract
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
function ContractHeader({ contract, documentTitle }) {
  const updatedAt = formatDateTime(contract?.updated_at);
  const version = contract?.version_number || 1;

  return (
    <div className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/80 shadow-[0_10px_30px_-25px_rgba(15,23,42,0.35)] backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex min-w-0 items-center gap-3 sm:gap-4">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-[#375AE7] via-indigo-500 to-cyan-400 text-white shadow-lg shadow-blue-200/60">
              <FileText size={20} />
            </div>

            <div className="min-w-0">
              <h1 className="truncate text-base font-semibold leading-tight text-slate-950 sm:text-lg">
                {documentTitle}
              </h1>

              <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-slate-500 sm:text-sm">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-2.5 py-1">
                  <Clock size={12} />
                  Last updated {updatedAt || 'N/A'}
                </span>
                <span className="rounded-full bg-slate-100 px-2.5 py-1">
                  v{version}
                </span>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-xs font-semibold text-emerald-700">
              <ShieldCheck size={14} />
              Secure preview
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
